import { InjectionToken } from '@angular/core';

/**
 * Configuration interface for CMS Post Library
 */
export interface BlogPostConfig {
  /**
   * Base URL for the CMS API
   * @example 'http://localhost:3001'
   * @example 'https://api.example.com'
   */
  apiBaseUrl: string;

  /**
   * Optional: Default organization ID for API calls
   */
  defaultOrgId?: string;

  /**
   * Optional: Enable debug logging
   * @default false
   */
  debug?: boolean;
}

/**
 * Injection token for Blog Post API configuration
 * 
 * @usage
 * ```typescript
 * // In app.config.ts or module providers
 * providers: [
 *   {
 *     provide: CMS_POST_API_CONFIG,
 *     useValue: {
 *       apiBaseUrl: environment.cmsApiBaseUrl
 *     }
 *   }
 * ]
 * ```
 */
export const CMS_POST_API_CONFIG = new InjectionToken<BlogPostConfig>(
  'CMS_POST_API_CONFIG',
  {
    providedIn: 'root',
    factory: () => {
      // Default configuration - should be overridden by consuming app
      console.warn(
        'CMS_POST_API_CONFIG not provided. Using default configuration. ' +
        'Please provide configuration using provideBlogPostLib() or by providing CMS_POST_API_CONFIG token.'
      );
      return {
        apiBaseUrl: 'http://localhost:3001',
        debug: false
      };
    }
  }
);
